import React from "react";
import qs from "qs";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { StyledGrid } from "components/simple";
import { StyledPageNum } from "./styled";

interface Props {
  activePage: number;
  setActivePage(p: number): void;
  totalPages: number;
}

const PageFinder: React.FC<Props> = ({ activePage, setActivePage, totalPages }: Props) => {
  const history = useHistory();
  const queryParams = qs.parse(history.location.search, {
    ignoreQueryPrefix: true
  });

  if (totalPages <= 1) return <></>;

  const previousPage = activePage - 1;
  const nextPage = activePage + 1;

  const handleClick = (n: number): void => {
    const newQueryParams = {
      ...queryParams,
      page: n
    };
    history.push("?" + qs.stringify(newQueryParams));

    setActivePage(n);
  };

  return (
    <StyledGrid container direction="row" justifyContent="center" alignItems="center">
      {activePage !== 1 && (
        <IconButton onClick={() => handleClick(previousPage)}>
          <ArrowBackIosIcon aria-label="left" fontSize="small" />
        </IconButton>
      )}
      {activePage >= 3 && (
        <StyledPageNum color={"default"} onClick={() => handleClick(1)}>
          1
        </StyledPageNum>
      )}
      {activePage >= 4 && <>...</>}
      {activePage !== 1 && (
        <StyledPageNum color={"default"} onClick={() => handleClick(previousPage)}>
          {previousPage}
        </StyledPageNum>
      )}
      {
        <StyledPageNum
          color={activePage ? "secondary" : "default"}
          onClick={() => handleClick(activePage)}
        >
          {activePage}
        </StyledPageNum>
      }
      {activePage !== totalPages && (
        <StyledPageNum color={"default"} onClick={() => handleClick(nextPage)}>
          {nextPage}
        </StyledPageNum>
      )}
      {activePage <= totalPages - 3 && <>...</>}
      {activePage <= totalPages - 2 && (
        <StyledPageNum color={"default"} onClick={() => handleClick(totalPages)}>
          {totalPages}
        </StyledPageNum>
      )}
      {activePage !== totalPages && (
        <IconButton onClick={() => handleClick(nextPage)}>
          <ArrowForwardIosIcon aria-label="right" fontSize="small" />
        </IconButton>
      )}
    </StyledGrid>
  );
};

export default PageFinder;
